import { PlatformModule } from '@angular/cdk/platform';
import { NgModule } from '@angular/core';

import { CustomStyleService } from './custom-style.service';
import { TitleService } from './title.service';

/**
 * @deprecated move browser features to providers
 */
@NgModule({
  imports: [PlatformModule],
  providers: [CustomStyleService, TitleService],
})
export class FmntsBrowserModule {}
